export default "__VITE_ASSET__BMTBj2$7__"